<template>
  <div
    class="principle-main"
    :style="{ background: `url(${data.bgImage}) 100% no-repeat` }"
    :class="{ 'principle-main-mobile': isMobile }"
  >
    <Base-title
      class="animate__animated"
      :class="animated"
      title="贝壳隐私保护原则"
    ></Base-title>
    <div class="headers animate__animated" :class="animated">
      我们的隐私保护原则贯穿于贝壳所有的技术应用、产品设计与业务运营中。在所提供的服务及产品的全生命周期（包括产品设计、开发、测试、上线、迭代等阶段）中融入了数据安全及隐私合规评估、检测及保护措施，并开展相应的安全合规管理。
    </div>
    <PrincipleItem :data="data" :animated="animated"></PrincipleItem>
  </div>
</template>
<script>
export default {
  // 优势 愿景
  name: "Principle",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    animated: {
      type: String,
      default: "animate__zoomIn",
    },
  },
};
</script>
<style lang="scss" scoped>
.principle-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover !important;
}
.headers {
  font-size: calc($multiple * 16px);
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #8b8b8b;
  line-height: calc($multiple * 36px);
  letter-spacing: 1px;
  margin-top: calc($multiple * 21px);
  margin-bottom: calc($multiple * 28px);
  width: calc($multiple * 1040px);
  min-width: calc($multiple * 1040px);
  text-align: center;
}
.principle-main-mobile {
  padding-top: 2.1rem;
  .headers {
    font-size: 0.72rem;
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #8b8b8b;
    line-height: 1.02rem;
    margin-top: 0.61rem;
    margin-bottom: 1.59rem;
    max-width: 16.18rem;
    min-width: auto;
    text-align: center;
  }
  .principle-item-main-mobile {
    padding: 0 1rem 0.51rem;
  }
}
</style>
